<div
  style="page-break-inside: avoid;"
  class="mt-4"
  *ngIf="incomeFormCapitalGainData.length > 0"
  [ngClass]="{
    'container': true,
    'return-view-background-print': printActive,
    'return-view-background': !printActive
  }"
>
  <div class="row mb-4">
    <div class="col-12 text-center">
      <strong>PARTICULARS OF INCOME FROM CAPITAL GAIN</strong>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-6">
      <strong>Taxpayer Name:</strong> {{ returnData?.profileData?.assesName }}
    </div>
    <div class="col-sm-6 text-right">
      <strong>Assessment Year:</strong> {{ returnData?.submissionInfo?.assessmentYear }}
    </div>
  </div>

  <div class="row mt-3 mb-5">
    <div class="col-sm-12">
      <strong>TIN</strong>
      <span class="ml-3" style="white-space: nowrap;">
        <input
          value="{{ tinChar }}"
          *ngFor="let tinChar of ((returnData?.profileData?.tin || '') + '').split('')"
          class="input-default"
          disabled
        />
      </span>
    </div>
  </div>

  <div *ngFor="let item of incomeFormCapitalGainData; let idx = index" style="page-break-inside: avoid;" class="row mb-5">
    <div class="col-12 mb-3 return-view-section-title">
      {{ getItemGainTypeTitle(item) }}
    </div>
    <ng-container *ngFor="let group of getParticularGroups(item); let lastGroup = last">
      <div class="col-12" *ngIf="group.type === 'text'" [class.mb-3]="!lastGroup">
        <div class="return-view-text-fields">
          <div class="return-view-text-field" *ngFor="let field of group.fields">
            <span class="return-view-text-label">{{ field.title }}:</span>
            <span class="return-view-text-value">{{ getTextFieldDisplayValue(item, field) }}</span>
          </div>
        </div>
      </div>

      <div class="col-12" *ngIf="group.type === 'amount'" [class.mb-3]="!lastGroup">
        <table class="table table-bordered income-capital-gain-table">
          <thead>
            <tr class="text-center">
              <th style="width: 70%">Particulars</th>
              <th style="width: 30%">Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let particular of group.fields">
              <td>{{ particular.title }}</td>
              <td class="text-right pr-3">{{ getValue(item, particular.key) | currencySeparatorBD }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>
  </div>
</div>
